import AddToGroupArrow from './AddToGroupArrow';

export default AddToGroupArrow;
